import type en from '../en/sites'
import type { Translation } from '../types'

/** Sites */
const sites: Translation<typeof en> = {
  "sites.deleted": "Locatie verwijderd",
  "sites.deleteFailed": "Kon de locatie niet verwijderen",
  "sites.syncTriggered": "Synchronisatie gestart",
  "sites.syncFailed": "Synchronisatie mislukt",
  "sites.managed": { one: "{count} locatie beheerd", other: "{count} locaties beheerd" },
  "sites.addSite": "Locatie toevoegen",
  "sites.site": "Locatie",
  "sites.location": "Plaats",
  "sites.lastSync": "Laatste synchronisatie",
  "sites.none": "Nog geen locaties — voeg uw eerste UniFi-locatie toe",
  "sites.notInLicence": "Niet in uw licentie",
  "sites.configureDevice": "Apparaat configureren",
  "sites.syncNow": "Nu synchroniseren",
  "sites.confirmDelete": "Locatie \"{name}\" verwijderen?",
  "sites.add.title": "UniFi-locatie toevoegen",
  "sites.add.name": "Naam van de locatie *",
  "sites.add.namePlaceholder": "Hoofdkantoor",
  "sites.add.locationPlaceholder": "Amsterdam, Nederland",
  "sites.add.descriptionPlaceholder": "Optionele omschrijving",
  "sites.add.apiKey": "UniFi API-sleutel *",
  "sites.add.apiKeyPlaceholder": "API-sleutel uit UniFi Network Application",
  "sites.add.signInWith": "Aanmelden met",
  "sites.add.signInKey": "API-sleutel (UniFi OS-console)",
  "sites.add.signInLogin": "Gebruikersnaam en wachtwoord (zelf gehoste Network Server)",
  "sites.add.username": "Gebruikersnaam *",
  "sites.add.password": "Wachtwoord *",
  "sites.add.loginHint": "Een zelf gehoste Network Server kent geen API-sleutels: gebruik er een lokaal account zonder verificatie in twee stappen. Het wachtwoord wordt versleuteld opgeslagen en nooit getoond.",
  "sites.add.controllerUrl": "Controller-URL",
  "sites.add.hintConsole": "UniFi OS-console (Dream Machine, Cloud Gateway, Cloud Key):",
  "sites.add.hintSelfHosted": "Zelf gehoste Network Server:",
  "sites.add.hintSiteManager": "Gebruik “+ Site Manager” voor consoles die u via unifi.ui.com bereikt.",
  "sites.add.siteId": "Site-ID",
  "sites.add.note": "Let op:",
  "sites.add.noteText": "Na het toevoegen wordt er automatisch een VPN-account aangemaakt. De locatie wordt actief zodra zij via VPN verbinding maakt.",
  "sites.synced": "Gesynchroniseerd",
  "sites.notFound": "Locatie niet gevonden",
  "sites.back": "Terug naar locaties",
  "sites.firmwareAvailable": "⬆ Firmware beschikbaar",
  "sites.lastSyncWhen": "Laatste synchronisatie {when}",
  "sites.never": "nooit",
  "sites.sync": "Synchroniseren",
  "sites.tab.overview": "Overzicht",
  "sites.tab.topology": "Topologie",
  "sites.tab.devices": "Apparaten ({count})",
  "sites.tab.vlans": "VLAN’s ({count})",
  "sites.tab.wifi": "Wifi ({count})",
  "sites.tab.clients": "Clients ({count})",
  "sites.tab.traffic": "Verkeer",
  "sites.tab.alerts": "Meldingen",
  "sites.tab.alertsCount": "Meldingen ({count})",
  "sites.connectedNow": "nu verbonden",
  "sites.connectionsUp": "verbindingen actief",
  "sites.download": "Download",
  "sites.upload": "Upload",
  "sites.uploadRate": "{rate} upload",
  "sites.experienceScore": "Ervaringsscore",
  "sites.wifiGood": "✓ Goede wifi-ervaring",
  "sites.wifiFair": "⚠ Redelijke wifi-ervaring",
  "sites.wifiPoor": "✕ Slechte wifi-ervaring",
  "sites.averageAcross": { one: "Gemiddelde van {count} draadloze client", other: "Gemiddelde van {count} draadloze clients" },
  "sites.wanConnections": "WAN-verbindingen",
  "sites.loadBalanced": "Load balancing",
  "sites.noWan": "Nog geen WAN-gegevens",
  "sites.throughput": "Doorvoer",
  "sites.noHistory": "Nog geen geschiedenis",
  "sites.noTopology": "Geen topologiegegevens — synchroniseer eerst de locatie",
  "sites.networkTopology": "Netwerktopologie",
  "sites.connectionsCount": { one: "{count} verbinding", other: "{count} verbindingen" },
  "sites.legend.wired": "— Bekabelde verbinding",
  "sites.legend.wireless": "– – Draadloze (mesh)verbinding",
  "sites.legend.ap": "📶 Access point",
  "sites.legend.switch": "🔀 Switch",
  "sites.legend.gateway": "🔒 Gateway",
  "sites.legend.clientCount": "🔵 = aantal clients",
  "sites.legend.update": "⬆ = update beschikbaar",
  "sites.model": "Model",
  "sites.type": "Type",
  "sites.experience": "Ervaring",
  "sites.firmwareUpdate": "⬆ Firmware-update beschikbaar",
  "sites.radios": "Radio’s",
  "sites.channel": "Kan. {channel}",
  "sites.utilization": "Gebruik: {percent}%",
  "sites.noDevices": "Geen apparaten",
  "sites.update": "⬆ Update",
  "sites.uptime": "UPTIME",
  "sites.clientsCaps": "CLIENTS",
  "sites.radioTable": "Radiotabel",
  "sites.channelUtilization": "Kanaalgebruik",
  "sites.portTable": "Poorttabel",
  "sites.port": "Poort",
  "sites.portN": "Poort {n}",
  "sites.speed": "Snelheid",
  "sites.down": "Inactief",
  "sites.upBadge": "ACTIEF",
  "sites.downBadge": "INACTIEF",
  "sites.uptimeDays": "{d}d {h}u",
  "sites.uptimeHours": "{h}u {m}m",
  "sites.vlanId": "VLAN-ID",
  "sites.purpose": "Doel",
  "sites.subnet": "Subnet",
  "sites.noVlans": "Geen VLAN’s",
  "sites.noWifi": "Geen wifinetwerken",
  "sites.guest": "GAST",
  "sites.clientsLower": "clients",
  "sites.busiest": "Drukst: {ap} ({count})",
  "sites.client": "Client",
  "sites.connection": "Verbinding",
  "sites.noClients": "Geen clients",
  "sites.conn.wired": "bekabeld",
  "sites.conn.wireless": "draadloos",
  "sites.dpi.0": "Overig",
  "sites.dpi.1": "Chatberichten",
  "sites.dpi.2": "P2P",
  "sites.dpi.3": "Bestandsoverdracht",
  "sites.dpi.4": "Streaming",
  "sites.dpi.5": "E-mail",
  "sites.dpi.6": "VoIP",
  "sites.dpi.7": "Gaming",
  "sites.dpi.8": "Sociale media",
  "sites.dpi.9": "Advertenties",
  "sites.dpi.10": "Web",
  "sites.dpi.11": "Beveiliging",
  "sites.dpi.other": "Cat. {n}",
  "sites.noDpi": "Geen DPI-gegevens — vereist UniFi met DPI ingeschakeld",
  "sites.trafficByCategory": "Verkeer per categorie",
  "sites.breakdown": "Verdeling",
  "sites.noActiveAlerts": "Geen actieve meldingen",
  "sites.config.field.enableDisable": "Verbinding ingeschakeld",
  "sites.config.help.enableDisable": "Zet de uplink aan of uit",
  "sites.config.field.priority": "Prioriteit",
  "sites.config.help.priority": "Het laagste getal wint als meerdere verbindingen actief zijn",
  "sites.config.field.failover": "Failover",
  "sites.config.help.failover": "Overschakelen naar een reserveverbinding als deze uitvalt",
  "sites.config.field.loadBalance": "Load balancing",
  "sites.config.help.loadBalance": "Verdeel sessies over actieve verbindingen",
  "sites.config.field.weights": "Verdeelgewicht",
  "sites.config.help.weights": "Aandeel van het verkeer voor deze verbinding",
  "sites.config.field.healthCheck": "Statuscontrole",
  "sites.config.help.healthCheck": "Test de verbinding en markeer haar als inactief bij een storing",
  "sites.config.field.smartQueue": "Smart Queue (QoS)",
  "sites.config.help.smartQueue": "Beperk bufferbloat bij belasting",
  "sites.config.field.staticIp": "Statisch IP-adres",
  "sites.config.help.staticIp": "Leeg laten voor DHCP",
  "sites.config.field.mtu": "MTU",
  "sites.config.help.mtu": "Meestal 1500, of 1492 voor PPPoE",
  "sites.config.field.simSwitch": "Actieve simsleuf",
  "sites.config.help.simSwitch": "Wisselen onderbreekt de verbinding even",
  "sites.config.field.apn": "APN",
  "sites.config.help.apn": "Naam van het toegangspunt van de provider",
  "sites.config.field.dataLimit": "Maandelijkse datalimiet",
  "sites.config.help.dataLimit": "Meldingen gaan af bij 90% hiervan",
  "sites.config.field.roaming": "Roaming toestaan",
  "sites.config.help.roaming": "Duur buiten het thuisnetwerk",
  "sites.config.field.bandLock": "Bandvergrendeling",
  "sites.config.help.bandLock": "Banden gescheiden door komma’s, leeg = automatisch",
  "sites.config.field.pin": "Pincode van de simkaart",
  "sites.config.field.ssid": "SSID",
  "sites.config.field.security": "Beveiliging",
  "sites.config.field.band": "Band",
  "sites.config.field.guest": "Gastnetwerk",
  "sites.config.help.guest": "Scheidt clients af van het LAN",
  "sites.config.field.vlanTag": "VLAN-tag",
  "sites.config.field.schedule": "Schema ingeschakeld",
  "sites.config.field.txPower": "Zendvermogen",
  "sites.config.field.fastRoaming": "Snelle roaming (802.11r)",
  "sites.config.field.mode": "Rol",
  "sites.config.field.frequency": "Frequentie",
  "sites.config.help.frequency": "60 GHz-radio’s: 58320, 60480, 62640, 64800 of 66000",
  "sites.config.field.channelWidth": "Kanaalbreedte",
  "sites.config.help.channelWidth": "Niet gebruikt op 60 GHz",
  "sites.config.field.protocol": "Protocol",
  "sites.config.help.protocol": "Alleen het 2,4/5 GHz-stuurprogramma \"wireless\"",
  "sites.config.field.linkKey": "Verbindingssleutel",
  "sites.config.help.linkKey": "Minstens 8 tekens; moet aan beide kanten gelijk zijn. Wordt na opslaan nooit meer getoond",
  "sites.config.field.linkTxPower": "Zendvermogen",
  "sites.config.help.linkTxPower": "Blijf binnen de limiet van uw regelgevend domein",
  "sites.config.field.linkSsid": "Verbindingsnaam (SSID)",
  "sites.config.help.linkSsid": "Moet aan beide kanten gelijk zijn",
  "sites.config.field.vlan": "VLAN",
  "sites.config.field.dhcp": "DHCP-server",
  "sites.config.field.firewall": "Firewall",
  "sites.config.field.portForward": "Port forwarding",
  "sites.config.field.staticRoutes": "Statische routes",
  "sites.config.field.dns": "DNS-servers",
  "sites.config.help.dns": "Gescheiden door komma’s",
  "sites.config.field.speedfusion": "SpeedFusion",
  "sites.config.field.reconnect": "Tunnel opnieuw verbinden",
  "sites.config.help.reconnect": "Verbreekt de bundeling en bouwt haar opnieuw op",
  "sites.config.field.createProfile": "Nieuw profiel",
  "sites.config.field.vpnClient": "VPN-client",
  "sites.config.field.reboot": "Apparaat herstarten",
  "sites.config.help.reboot": "Het apparaat is 1-2 minuten offline",
  "sites.config.field.firmwareCheck": "Controleren op firmware",
  "sites.config.field.firmwareUpgrade": "Firmware installeren",
  "sites.config.help.firmwareUpgrade": "Installeert de nieuwste beschikbare versie",
  "sites.config.field.backup": "Configuratie back-uppen",
  "sites.config.field.restore": "Configuratie herstellen",
  "sites.config.field.ntp": "NTP-server",
  "sites.config.field.timezone": "Tijdzone",
  "sites.config.field.hostname": "Hostnaam",
  "sites.config.field.adminPassword": "Beheerderswachtwoord",
  "sites.config.section.wan": "WAN",
  "sites.config.blurb.wan": "Gedrag van de uplink, failover en load balancing",
  "sites.config.section.cellular": "Mobiel",
  "sites.config.blurb.cellular": "Simkaart, APN, datalimieten en roaming",
  "sites.config.section.wifi": "Wifi",
  "sites.config.blurb.wifi": "SSID’s, beveiliging en radio-instellingen",
  "sites.config.section.link": "Straalverbinding",
  "sites.config.blurb.link": "Instellingen voor punt-tot-punt- en punt-tot-multipuntverbindingen. Wijzig eerst elk station en daarna binnen 10 minuten het access point; de frequentie stelt u alleen op het access point in.",
  "sites.config.section.network": "Netwerk",
  "sites.config.blurb.network": "VLAN’s, DHCP, firewall en routering",
  "sites.config.section.tunnel": "Tunnels",
  "sites.config.blurb.tunnel": "SpeedFusion- en VPN-clientprofielen",
  "sites.config.section.system": "Systeem",
  "sites.config.blurb.system": "Herstarten, firmware, tijd en identiteit",
  "sites.config.option.ap-ptp": "Access point — punt-tot-punt",
  "sites.config.option.ap-ptmp": "Access point — punt-tot-multipunt",
  "sites.config.option.station": "Station (andere kant / CPE)",
  "sites.config.option.open": "open",
  "sites.config.option.both": "beide",
  "sites.config.option.auto": "automatisch",
  "sites.config.option.low": "laag",
  "sites.config.option.medium": "gemiddeld",
  "sites.config.option.high": "hoog",
  "sites.config.option.any": "elk",
  "sites.config.applied": { one: "{count} wijziging toegepast", other: "{count} wijzigingen toegepast" },
  "sites.config.someFailed": "Sommige wijzigingen zijn mislukt",
  "sites.config.unsupportedHere": "Niet ondersteund op dit apparaat",
  "sites.config.title": "{name} configureren",
  "sites.config.subtitle": "Alleen opties die dit apparaat ondersteunt worden getoond",
  "sites.config.hide": "Verbergen",
  "sites.config.history": "Geschiedenis",
  "sites.config.apply": "{count} toepassen",
  "sites.config.missing": "Ontbrekende configuratie: {items} — verbind deze locatie opnieuw om configureren mogelijk te maken.",
  "sites.config.readOnly": "{label} is via dit dashboard alleen-lezen. Monitoring werkt gewoon.",
  "sites.config.readFailed": "De huidige instellingen konden niet van het apparaat worden gelezen",
  "sites.config.readFailedNote": "De velden hieronder zijn leeg omdat ze onbekend zijn, niet omdat ze uit staan.",
  "sites.config.available": "Beschikbaar op dit apparaat",
  "sites.config.appliesTo": "Geldt voor",
  "sites.config.notSupportedBy": "Niet ondersteund door {label}",
  "sites.config.raw": "Ruwe apparaatstatus",
  "sites.config.changed": "gewijzigd",
  "sites.config.notReported": "Huidige status niet gemeld door het apparaat",
  "sites.config.unknownState": "Huidige status onbekend",
  "sites.config.discard": "Deze wijziging ongedaan maken",
  "sites.config.historyTitle": "Geschiedenis van configuratiewijzigingen",
  "sites.config.noChanges": "Nog geen wijzigingen vastgelegd",
  "sites.config.when": "Wanneer",
  "sites.config.section": "Onderdeel",
  "sites.config.field": "Veld",
  "sites.config.value": "Waarde",
  "sites.search": "Locaties zoeken",
  "sites.searchPlaceholder": "Zoeken op naam…",
  "sites.brand": "Merk",
  "sites.allBrands": "Alle merken",
  "sites.noneMatch": "Geen locaties gevonden",
  "sites.matching": { one: "{count} locatie gevonden", other: "{count} locaties gevonden" },
  "sites.config.offline.copy": "Deze unit is offline — de instellingen zoals gelezen {when}. Wijzigingen worden bewaard en verstuurd zodra hij terug is.",
  "sites.config.offline.none": "Deze unit is nog niet bereikt — wijzigingen worden bewaard en bij het eerste contact verstuurd.",
  "sites.config.offline.save": "Bewaren voor later ({count})",
  "sites.config.offline.saved": { one: "{count} wijziging bewaard voor als de unit terug is", other: "{count} wijzigingen bewaard voor als de unit terug is" },
  "sites.config.offline.pendingValue": "wacht: {value} · {by} · {when}",
  "sites.pending.title": "Wachtende wijzigingen",
  "sites.pending.waitingUnit": "Verstuurd zodra de unit terug is",
  "sites.pending.conflict": "Op de unit gewijzigd in {unit} — de jouwe: {mine}",
  "sites.pending.keepMine": "Mijne houden",
  "sites.pending.keepUnit": "Die van de unit houden",
  "sites.pending.waitingFor": "Wacht tot {names} eerst zijn eigen linkwijziging heeft",
  "sites.pending.release": "Toch versturen",
  "sites.pending.failed": "Mislukt: {error}",
  "sites.pending.discard": "Verwerpen",
  "sites.pending.decision": "Beslissing nodig",
  "sites.pending.count": { one: "{count} wacht", other: "{count} wachten" },
  "sites.config.offline.noneSeen": "Deze unit antwoordt nu niet en de instellingen zijn nog niet gelezen — wijzigingen worden bewaard en bij het volgende contact verstuurd.",
  "sites.cloud.status.OK": "Werkt",
  "sites.cloud.status.WAITING_VPN": "Wacht op zijn VPN",
  "sites.cloud.status.FAILED": "Mislukt",
  "sites.cloud.reach.PUBLIC": "Op een adres",
  "sites.cloud.reach.VIA_SITE_VPN": "Via de VPN van een locatie",
  "sites.cloud.reach.OWN_VPN": "De eigen VPN-verbinding van de controller",
  "sites.cloud.reachHint.PUBLIC": "De controller antwoordt op een openbaar adres met een geldig certificaat.",
  "sites.cloud.reachHint.VIA_SITE_VPN": "Een apparaat op een van je locaties met een VPN-verbinding stuurt de poort van de controller door — geen cloudabonnement, geen open poort.",
  "sites.cloud.reachHint.OWN_VPN": "De computer van de controller maakt zelf verbinding met de VPN van het platform (OpenVPN op Windows of Linux).",
  "sites.cloud.reachHint.needsVpn": "Hiervoor is het recht nodig om VPN-verbindingen te beheren.",
  "sites.cloud.connectionName": "Naam",
  "sites.cloud.connectionNamePlaceholder": "bijv. Controller hoofdkantoor",
  "sites.cloud.reachLabel": "Hoe het dashboard de controller bereikt",
  "sites.cloud.address": "Adres van de controller",
  "sites.cloud.addressHint": "Een geldig certificaat is nodig: op een openbaar adres bewijst niets anders wie er antwoordt.",
  "sites.cloud.noVpnSites": "Nog geen van je locaties heeft een VPN-verbinding. Voeg er eerst een toe (een MikroTik, een UniFi-gateway of een andere VPN-client op die plek).",
  "sites.cloud.viaSite": "Locatie",
  "sites.cloud.chooseSite": "Kies een locatie",
  "sites.cloud.port": "Poort van de controller",
  "sites.cloud.forwardIntro": "Stuur op het apparaat bij {site} poort {port} van zijn VPN-adres {ip} door naar het LAN-adres van de controller.",
  "sites.cloud.lanAddress": "LAN-adres van de controller",
  "sites.cloud.forwardMikrotik": "Op een MikroTik, in de terminal:",
  "sites.cloud.lanPlaceholder": "<LAN-adres van de controller>",
  "sites.cloud.credentials": "Inloggegevens van Omada",
  "sites.cloud.credentialsWhere": "Open in de Omada-controller {menu}, voeg een applicatie toe in de modus Client en kopieer de Client ID en het Client secret. De Omada ID staat op dezelfde pagina.",
  "sites.cloud.omadacId": "Omada ID",
  "sites.cloud.clientId": "Client ID",
  "sites.cloud.clientSecret": "Client secret",
  "sites.cloud.keptPlaceholder": "Ingesteld — laat leeg om te houden",
  "sites.cloud.registerTitle": "Omada-locaties toevoegen",
  "sites.cloud.registerSubtitle": "De locaties van een TP-Link Omada-controller, bereikt via je VPN of op een adres",
  "sites.cloud.savedWaiting": "Bewaard — wacht op de VPN-verbinding van de controller",
  "sites.cloud.connected": "Verbonden met de controller",
  "sites.cloud.connectFailed": "Verbinden mislukt",
  "sites.cloud.otherConnection": "Andere verbinding",
  "sites.cloud.failed": "Laatste fout: {reason}",
  "sites.cloud.editInSettings": "Verbinding bewerken",
  "sites.cloud.useConnection": "Een verbinding gebruiken",
  "sites.cloud.newConnection": "Een nieuwe verbinding",
  "sites.cloud.connect": "Verbinden",
  "sites.cloud.downloadFailed": "Downloaden mislukt",
  "sites.cloud.waitingTitle": "Wacht op de VPN-verbinding van de controller",
  "sites.cloud.waitingText": "Download deze VPN-verbinding en start hem op de computer van de controller. Zodra de tunnel op staat worden de inloggegevens gecontroleerd en verschijnen de locaties van de controller hier — deze pagina kijkt elke 10 seconden opnieuw.",
  "sites.cloud.downloadOvpn": ".ovpn downloaden",
  "sites.cloud.ovpnWindows": "Windows: installeer OpenVPN, importeer het bestand en maak verbinding; laat de OpenVPN-service automatisch starten zodat de tunnel na een herstart terugkomt.",
  "sites.cloud.ovpnLinux": "Linux: kopieer het bestand naar /etc/openvpn/client/velanox.conf en voer systemctl enable --now openvpn-client@velanox uit.",
  "sites.cloud.added": { one: "{count} locatie toegevoegd", other: "{count} locaties toegevoegd" },
  "sites.cloud.addFailed": "Toevoegen van de locaties mislukt",
  "sites.cloud.sitesFailed": "De locaties van de controller konden niet worden gelezen: {reason}",
  "sites.cloud.controllerSites": "Locaties van de controller",
  "sites.cloud.noControllerSites": "De controller heeft geen locaties.",
  "sites.cloud.deviceCount": { one: "{count} apparaat", other: "{count} apparaten" },
  "sites.cloud.alreadyAdded": "Toegevoegd",
  "sites.cloud.addSites": { one: "{count} locatie toevoegen", other: "{count} locaties toevoegen" },
  "sites.cloud.through": "Via {name} · {reach}",
  "sites.cloud.synced": "gesynchroniseerd {when}",
  "sites.cloud.configure": "Configureren",
  "sites.cloud.devicesOnline": "Apparaten online",
  "sites.cloud.clients": "Clients",
  "sites.cloud.uplinksUp": "Uplinks actief",
  "sites.cloud.openAlerts": "Open meldingen",
  "sites.cloud.devices": "Apparaten",
  "sites.cloud.noDevices": "Nog geen apparaten op deze locatie.",
  "sites.cloud.type": "Type",
  "sites.cloud.uptime": "Uptime",
  "sites.cloud.deviceType.ap": "Access point",
  "sites.cloud.deviceType.switch": "Switch",
  "sites.cloud.deviceType.gateway": "Gateway",
  "sites.cloud.deviceType.other": "Overig",
  "sites.cloud.updateAvailable": "Update beschikbaar",
  "sites.cloud.restart": "Herstarten",
  "sites.cloud.restartSent": "Herstart verstuurd",
  "sites.cloud.restartConfirm": "{name} herstarten? De clients verliezen ongeveer twee minuten hun verbinding.",
  "sites.cloud.upgrade": "Firmware bijwerken",
  "sites.cloud.upgradeSent": "Firmware-update gestart",
  "sites.cloud.upgradeConfirm": "De firmware van {name} bijwerken? Het apparaat herstart en de clients verliezen ongeveer twee minuten hun verbinding.",
  "sites.cloud.noClients": "Geen clients verbonden.",
  "sites.cloud.connection": "Verbinding",
  "sites.cloud.blocked": "Geblokkeerd",
  "sites.cloud.wireless": "Draadloos",
  "sites.cloud.wired": "Bekabeld",
  "sites.cloud.unblock": "Deblokkeren",
  "sites.cloud.unblocked": "Gedeblokkeerd",
  "sites.cloud.block": "Blokkeren",
  "sites.cloud.blockedDone": "Geblokkeerd",
  "sites.cloud.blockConfirm": "{name} blokkeren? Het kan pas weer verbinden als het gedeblokkeerd is.",
  "sites.cloud.reconnect": "Opnieuw verbinden",
  "sites.cloud.reconnectSent": "Opnieuw verbinden verstuurd",
  "sites.cloud.uplinks": "Uplinks",
  "sites.cloud.noUplinks": "Geen uplinks gemeld.",
  "sites.cloud.up": "Actief",
  "sites.cloud.down": "Uitgevallen",
  "sites.cloud.alerts": "Meldingen",
  "sites.cloud.events": "Recente gebeurtenissen van {vendor}",
  "sites.cloud.eventsFailed": "De controller antwoordde niet: {reason}",
  "sites.cloud.noEvents": "Geen recente gebeurtenissen.",
  "sites.config.field.ssidOn": "SSID aan",
  "sites.config.field.wifiKey": "WiFi-sleutel",
  "sites.config.help.wifiKey": "Alleen schrijven: de huidige sleutel wordt nooit getoond",
  "sites.config.field.networkName": "Netwerknaam",
  "sites.config.field.siteName": "Locatienaam op de controller",
  "sites.config.help.siteName": "De eigen naam van de locatie in het dashboard blijft zoals hij is",
  "sites.config.secretSet": "Ingesteld — typ een nieuwe om hem te wijzigen",
  "sites.cloud.lanAddressHint": "Zijn eigen adres op het netwerk ter plaatse: de doorsturing gaat erheen, en het netwerk waarop hij zit houdt van hieruit zijn VLAN.",
  "sites.cloud.controllerPort": "Eigen poort van de controller",
  "sites.cloud.controllerPortHint": "8043 bij een softwarecontroller, 443 bij een OC200 of OC300",
  "sites.cloud.secretAgain": "Typ het client secret opnieuw als het adres, de locatie of de poort wijzigt: het wordt nooit vanzelf naar een nieuw adres gestuurd.",
  "sites.config.historySection.devices": "Apparaten",
  "sites.config.historySection.clients": "Clients",
  "sites.removeSite": "Locatie verwijderen",
  "sites.removeConfirm": "De locatie \"{name}\" verwijderen? De geschiedenis, meldingen, instellingen en VPN-verbinding gaan mee. Dit kan niet ongedaan worden gemaakt.",
  "sites.config.help.radioOn": "Een radio met een verbinding uitzetten verbreekt die verbinding",
  "sites.vpn.title": "VPN-verbinding",
  "sites.vpn.connected": "Verbonden",
  "sites.vpn.waiting": "Wacht op de VPN-verbinding",
  "sites.vpn.notConnected": "Niet verbonden",
  "sites.vpn.waitingPage": "Wacht op de VPN-verbinding: de gegevens van het apparaat verschijnen hier zodra het verbindt",
  "sites.vpn.tunnelAddress": "Tunneladres",
  "sites.vpn.lastSeen": "Laatst verbonden",
  "sites.vpn.never": "Nooit",
  "sites.vpn.loadHint": "Laad dit bestand op de router als OpenVPN-client, en laat HTTPS (poort 443) vanaf de VPN toe op de router (op een Teltonika: Netwerk → Firewall → Traffic rules, van zone openvpn naar het apparaat, TCP 443, accepteren); de locatie komt hier online zodra die verbindt",
  "sites.vpn.download": ".ovpn downloaden",
  "sites.vpn.downloadFailed": "Downloaden mislukt",
  "sites.vpn.renew": "Certificaat vernieuwen",
  "sites.vpn.renewed": "Nieuw VPN-bestand aangemaakt voor de locatie",
  "sites.vpn.renewFailed": "Er kon geen nieuw VPN-bestand worden aangemaakt",
  "sites.signIn.change": "Aanmelding wijzigen",
  "sites.signIn.title": "De aanmelding van {name} wijzigen",
  "sites.signIn.hint": "Een leeg veld houdt wat is opgeslagen. Wachtwoorden en tokens worden versleuteld opgeslagen en nooit getoond.",
  "sites.signIn.user": "Gebruikersnaam",
  "sites.signIn.password": "Wachtwoord",
  "sites.signIn.token": "API-token",
  "sites.signIn.apiKey": "API-sleutel",
  "sites.signIn.save": "Aanmelding opslaan",
  "sites.signIn.saved": "Aanmelding opgeslagen",
  "sites.signIn.savedText": "Het apparaat wordt er nu opnieuw mee gevraagd",
  "sites.signIn.failed": "De aanmelding kon niet worden opgeslagen",
  "sites.direct.toggle": "VPN-verbinding uitschakelen en een direct adres of IP gebruiken",
  "sites.add.vpnLine": "Bereikt via de VPN-verbinding, op het tunneladres van de gateway — vanzelf gevonden",
  "sites.event.brand": "Evenementen",
  "sites.event.badge": "Evenement",
  "sites.event.archived": "Gearchiveerd",
  "sites.archivedHint": "Locaties van afgesloten evenementen: ze blijven hier zo lang als de archieftermijn in de verhuurinstellingen en worden daarna verwijderd.",
  "sites.event.rentalEvent": "Verhuurevenement",
  "sites.event.period": "Huurperiode",
  "sites.event.material": "Materiaal weg en terug",
  "sites.event.devices": "Apparaten",
  "sites.event.device": "Apparaat",
  "sites.event.cameIn": "Zat in",
  "sites.event.state": "Status",
  "sites.event.uptime": "Uptime",
  "sites.event.clients": "Clients",
  "sites.event.traffic": "Verkeer",
  "sites.event.lastSeen": "Laatst gezien",
  "sites.event.noDevices": "Geen apparaat van wat geladen is, is nu weg",
  "sites.event.hidden": { one: "{count} apparaat verborgen: je mag de locatie ervan niet zien", other: "{count} apparaten verborgen: je mag hun locaties niet zien" },
  "sites.event.alerts": "Meldingen",
  "sites.event.noAlerts": "Geen meldingen",
  "sites.event.resolved": "opgelost",
  "sites.event.clientList": "Netwerkclients",
  "sites.event.noClients": "Geen clients",
  "sites.event.loads": "Wat er mee ging",
  "sites.event.noLoads": "Er is nog niets mee gegaan",
  "sites.event.wentOut": "Weg {when} · {who}",
  "sites.event.cameBack": "Terug {when} · {who}: {status}",
  "sites.event.stillOut": "nog weg",
  "sites.event.cameBackOf": "{back} van {out} terug",
  "sites.event.graphs": "Grafieken",
  "sites.event.range": "Periode",
  "sites.event.range24h": "24 u",
  "sites.event.range3d": "3 dagen",
  "sites.event.range1w": "1 week",
  "sites.event.rangeThisMonth": "Deze maand",
  "sites.event.rangeLastMonth": "Vorige maand",
  "sites.event.rangeCustom": "Zelf kiezen",
  "sites.event.from": "Van",
  "sites.event.to": "Tot",
  "sites.event.rangeInvalid": "Het einde ligt vóór het begin",
  "sites.event.totalInRange": "In deze periode: ↓ {rx} · ↑ {tx}",
  "sites.event.graphTraffic": "Totaal verkeer",
  "sites.event.graphDevices": "Apparaten online en offline",
  "sites.event.noSamples": "Niets vastgelegd in deze periode: de grafieken vullen zich zolang het materiaal uit is",
  "sites.event.asTable": "Als tabel tonen",
  "sites.event.time": "Tijd",
  "sites.cloud.username": "Gebruikersnaam",
  "sites.cloud.password": "Wachtwoord",
  "sites.cloud.registerTitleSz": "Ruckus-locaties toevoegen",
  "sites.cloud.registerSubtitleSz": "De zones van een Ruckus SmartZone-controller, bereikt via de VPN van een locatie of op een adres",
  "sites.cloud.credentialsSz": "Aanmeldgegevens van SmartZone",
  "sites.cloud.credentialsWhereSz": "Een SmartZone-beheerder met een rol met lees- en schrijfrechten ({menu})",
  "sites.cloud.secretAgainSz": "Typ het wachtwoord opnieuw wanneer het adres, de locatie of de poort verandert: het wordt nooit vanzelf naar een nieuw adres gestuurd.",
  "sites.cloud.controllerPortHintSz": "8443 op SmartZone",
  "sites.cloud.siteFirmware": "AP-firmware bijwerken",
  "sites.cloud.siteFirmwareCurrent": "Huidige versie",
  "sites.cloud.siteFirmwareNew": "Nieuwe versie",
  "sites.cloud.siteFirmwareNone": "Geen nieuwere versie op de controller",
  "sites.cloud.siteFirmwareUpdate": "Bijwerken",
  "sites.cloud.siteFirmwareConfirm": "Elk access point van deze locatie herstart om naar {version} te gaan. Doorgaan?",
  "sites.cloud.siteFirmwareSent": "Firmware-update gestart",
  "sites.config.wifiOnly": "De locaties van deze controller hebben alleen WiFi-instellingen: VLAN’s worden per WiFi-netwerk ingesteld.",
  "sites.event.comment": "Opmerking",
  "sites.event.commentOf": "Opmerking bij {name}",
  "sites.event.commentPlaceholder": "Opmerking toevoegen",
  "sites.event.commentSaved": "Opmerking opgeslagen",
  "sites.event.commentFailed": "De opmerking is niet opgeslagen",
  "sites.event.commentBy": "{name}, {when}",
  "sites.add.choose": "Wat voegt u toe?",
  "sites.speedTest": "Snelheidstest ↓ {down} ↑ {up}",
  "sites.speedTestAt": "De laatste snelheidstest van de gateway, {when}: wat de lijn aankan",
  "sites.dataUsed": "Dataverbruik ({period}): ↓ {rx} ↑ {tx}",
}

export default sites
